export function generateKey(requestName: string, requestParams: unknown): string {
  return `${requestName}:${JSON.stringify(requestParams)}`;
}
